export const ORDER_ACTION_NONE: string = 'ORDER_ACTION_NONE';
export const ORDER_ACTION_RETURN: string = 'ORDER_ACTION_RETURN';
export const ORDER_ACTION_EXCHANGE: string = 'ORDER_ACTION_EXCHANGE';
